import React, { FunctionComponent as FC } from 'react';

import { Text, TextProps } from '@chakra-ui/react';
import { MdContentCopy } from 'react-icons/md';
import { MFlex, MIcon } from './chakra';
import { MClipboardCopyBox } from './MClipboardCopyBox';

export interface MIDCopyBoxProps extends TextProps {
  copyValue: string;
  displayText?: string;
  isDisabled?: boolean;
  tooltipMessage?: string;
  displayIcon?: boolean;
}

export const MIDCopyBox: FC<MIDCopyBoxProps> = React.forwardRef<
  any,
  MIDCopyBoxProps
>(
  (
    {
      copyValue,
      displayText,
      fontSize = 'sm',
      isDisabled = false,
      tooltipMessage = 'Copy to Clipboard',
      displayIcon = true,
      ...rest
    }: MIDCopyBoxProps,
    ref,
  ) => {
    const renderContent = () => {
      return (
        <MFlex alignItems="center">
          <Text
            fontSize={fontSize}
            fontWeight="normal"
            color={isDisabled ? 'tGray.lightPurple' : 'tPurple.dark'}
            cursor="pointer"
            {...rest}
          >
            {displayText || copyValue}
          </Text>
          {displayIcon && (
            <MIcon
              as={MdContentCopy}
              // Sized to match the other action icons in the page header row
              // (RecordAuditInfoPopover, EntityJsonViewerIcon — both 16px)
              // so vertical alignment in the icon strip is consistent.
              boxSize={4}
              mx={1}
              color="tPurple.dark"
              cursor="pointer"
            />
          )}
        </MFlex>
      );
    };

    return (
      <MClipboardCopyBox
        tooltipMessage={tooltipMessage}
        {...rest}
        copyValue={copyValue}
        renderContent={renderContent}
      />
    );
  },
);
